'use strict';
import Api from '../abstract';

export let GET_LIST_WORKSPACE = (params, successCallback, errorCallback) => {
    let url = `/user/link/workspaces?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_LIST_APPS = (params, successCallback, errorCallback) => {
    let url = `/user/link/${params.payload.spaceId}/apps?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_LIST_VIEWS = (params, successCallback, errorCallback) => {
    let queryString = params.payload.queryString || '';
    let url = `/user/link/${params.payload.appId}/views?space_id=${params.payload.space_id}`;
    if (queryString) {
        url += `&${queryString}`;
    }
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let CREATE_LIST_CONNECT = (params, successCallback, errorCallback) => {
    let url = `/user/links`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let UPDATE_LIST_CONNECT = (params, successCallback, errorCallback) => {
    let url = `/user/links/${params.payload.id}`;
    let data = params.payload.data;
    return Api.put(url, data).then(successCallback).catch(errorCallback);
};

export let UPDATE_NOTES = (params, successCallback, errorCallback) => {
  let url = `/user/links/${params.payload.id}/updateNotes`;
  let data = params.payload.data;
  return Api.put(url, data).then(successCallback).catch(errorCallback);
};

export let DETAIL_LIST_CONNECT = (params, successCallback, errorCallback) => {
    let url = `/user/links/${params.payload.id}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_LIST_USER_CONNECT = (params, successCallback, errorCallback) => {
    let url = `/user/links?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_LIST_CONNECT_OF_MEMBER = (params, successCallback, errorCallback) => {
    let url = `/user/links/member?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_ACCESS_TOKEN = (params, successCallback, errorCallback) => {
    let url = `/user/setting/google/access_token`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let DELETE_USER_CONNECT = (params, successCallback, errorCallback) => {
    let url = `/user/links/${params.payload.id}`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};

export let CHANGE_STATUS_USER_CONNECT = (params, successCallback, errorCallback) => {
    let url = `/user/links/${params.payload.id}`;
    return Api.patch(url).then(successCallback).catch(errorCallback);
};

export let UPDATE_USER_CONNECT = (params, successCallback, errorCallback) => {
    let url = `/user/links/${params.payload.id}/sync`;
    return Api.post(url).then(successCallback).catch(errorCallback);
};

export let GET_LIST_WORKSPACE_ALL = (params, successCallback, errorCallback) => {
    let url = `/user/link/workspaces/list`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_USER_CONNECT_NOT_PERMISSION = (params, successCallback, errorCallback) => {
    let url = `/user/links/${params.payload.id}/information`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_SHEET_OF_SPREADSHEETS = (params, successCallback, errorCallback) => {
    let url = `https://sheets.googleapis.com/v4/spreadsheets/${params.payload.idFile}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let GET_ALL_FIELDS_FILTER = (params, successCallback, errorCallback) => {
    let url = params.payload.spaceUid ? `/user/links/${params.payload.appId}/all-fields?space_id=${params.payload.spaceUid}` : `/user/links/${params.payload.appId}/all-fields`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};
